"use strict";

var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.TextInputProvider = exports.TextInputConsumer = void 0;
var React = _interopRequireWildcard(require("react"));
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
/*:: type Context = {|
  inputRef: React.Ref<'input'>
|};*/
/*:: type Props = {|
  children?: React.Node,
  value: Context
|};*/
var TextInputContext = React.createContext();
var useTextInputContext = function useTextInputContext() {
  return React.useContext(TextInputContext);
};
var TextInputProvider = exports.TextInputProvider = function TextInputProvider(_ref /*:: */) {
  var children = _ref /*:: */.children,
    value = _ref /*:: */.value;
  return /*#__PURE__*/React.createElement(TextInputContext.Provider, {
    value: value
  }, children);
};
var TextInputConsumer = exports.TextInputConsumer = TextInputContext.Consumer;
var _default = exports.default = useTextInputContext;
//# sourceMappingURL=TextInputContext.js.map